export const DOCUMENT_QUERY_KEY = 'knowledgeSearchDocument';

export const DOCUMENTS_QUERY_KEY = 'knowledgeSearchDocuments';
